import {
  apps,
  blogCategories,
  blogPosts,
  contactChannels,
  expertiseAreas,
  featuredMetrics,
  homepageSections,
  navigationItems,
  careerHighlights,
  siteProfile,
  socialLinks,
  skillCards,
  technologyStack,
} from "../../data/siteData";

export const fallbackPosts = blogPosts;
export const fallbackApps = apps;

export const fallbackPages = [
  {
    id: "home",
    slug: "anasayfa",
    title: "Anasayfa",
    excerpt: siteProfile.shortBio,
    content: siteProfile.extendedBio,
    coverImage: "",
    seo: null,
  },
  {
    id: "about",
    slug: "hakkimda",
    title: "Hakkimda",
    excerpt: siteProfile.extendedBio,
    content: siteProfile.extendedBio,
    coverImage: "",
    seo: null,
  },
  {
    id: "contact",
    slug: "iletisim",
    title: "Iletisim",
    excerpt: "Iletisim bilgileri ve sosyal baglantilar.",
    content: "Yeni proje ve is birlikleri icin iletisime gecebilirsiniz.",
    coverImage: "",
    seo: null,
  },
];

export const fallbackCategories = blogCategories
  .filter((item) => item !== "All")
  .map((item, index) => ({
    id: index + 1,
    slug: item.toLowerCase().replace(/\s+/g, "-"),
    name: item,
    count: fallbackPosts.filter((post) => post.category === item).length,
  }));

export const fallbackTags = [...new Set(fallbackPosts.flatMap((post) => post.tags))]
  .map((item, index) => ({
    id: index + 1,
    slug: item.toLowerCase().replace(/\s+/g, "-"),
    name: item,
    count: fallbackPosts.filter((post) => post.tags.includes(item)).length,
  }));

export const fallbackSiteSettings = {
  siteProfile,
  homepageSections,
  featuredMetrics,
  expertiseAreas,
  technologyStack,
  careerHighlights,
  skillCards,
  contactInfo: {
    email: siteProfile.email,
    location: siteProfile.location,
    channels: contactChannels,
  },
  socialLinks,
  header: {
    ctaLabel: "Proje Baslat",
    ctaPath: "/iletisim",
  },
  footer: {
    heading: "Temiz mimari, premium deneyim ve guclu dijital algi.",
    copy:
      "Kisisel marka siteleri, urun vitrinleri ve icerik odakli deneyimler icin tasarim ile muhendisligi tek cizgide bulusturuyorum.",
  },
  seo: {
    defaultTitle: siteProfile.name,
  },
};

export const fallbackNavigation = {
  items: navigationItems,
};
